/**
 * Форматирует десятичное число как процент
 * @param decimal - десятичное число (например 0.01 = 1%)
 * @param decimals - количество знаков после запятой (по умолчанию 0)
 * @returns строка с процентами
 *
 * @example
 * formatPercentage(0.01)    // → '1%'
 * formatPercentage(0.156)   // → '16%'
 * formatPercentage(0.156, 1) // → '15.6%'
 * formatPercentage(1.5)     // → '150%'
 */
export function formatPercentage(decimal: number, decimals: number = 0): string {
  if (typeof decimal !== 'number' || isNaN(decimal)) {
    return '0%'
  }

  const percentage = decimal * 100
  return `${percentage.toFixed(decimals)}%`
}
